import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import directions from '../directions';
import Chevron from './Chevron';
import classes from './DirectionPicker.styles.less';
export default function DirectionPicker({ className, value, onChange }) {
    const [theme] = useTheme();
    const contols = directions.map((direction) => (_jsx("button", { type: "button", onClick: () => onChange(direction), className: cx(classes.control, { [classes.active]: value === direction }), children: _jsx(Chevron, { direction: direction }) }, direction)));
    contols.splice(4, 0, _jsx("div", { className: classes.blank }, "blank"));
    return _jsx("div", { className: cx(classes.wrapper, classes[theme], className), children: contols });
}
